import { render, staticRenderFns } from "./driver-rating.vue?vue&type=template&id=587c9c10&"
import script from "./driver-rating.vue?vue&type=script&lang=js&"
export * from "./driver-rating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports